import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import Fileupload from "../FileuploadWithPreview/Fileupload";
import trash from "../../../src/assests/images/trash.svg";
import plus from "../../../src/assests/images/plus_red.svg";
import galleryadd from "../../../src/assests/images/gallery-add.svg";
import cancel from "../../../src/assests/images/close-circle.svg"; // Assuming this is the delete icon used by Fileupload
import { getToken } from "../../utils/utils";
import { uploadimagetask } from "../../pages/create-task/api";
import { useTaskContext } from "../store/AlltasksContext";

interface MediaItem {
  type: "image" | "video";
  url: string;
  file: File;
}

interface InstructionItem {
  id: number;
  value: string;
  value_hi: string;
  smallimage: string;
  bigimage: string;
  media?: MediaItem[];
}

interface InstructionProps {
  initialInstructions?: InstructionItem[];
  placeholderPrefix?: string;
  containerClassName?: string;
  idid?: number;
  textvalue?: string;
  multiples?: any[];
  selectedValue?: string | null;
  text?: string;
  sectionsData1?: string;
  selectedLabel?: string | null;
  updateSectionsData2?: (sectionId: number, selectedLabel: string | null) => void;
  lang?: {
    addInstruction: string;
  };
}

const Instruction: React.FC<InstructionProps> = ({
  initialInstructions = [{ id: 1, value: "", value_hi: "", smallimage: "", bigimage: "", media: [] }],
  placeholderPrefix = "Instruction",
  containerClassName = "inst-box",
  idid,
  lang = { addInstruction: "Add Instruction" },
}) => {
  const { id } = useParams<{ id: string }>();
  const [imageMap, setImageMap] = useState<Record<number, string[]>>({});

  const {
    sectionsData,
    setSectionsData,
    educationalData,
    seteducationalData,
    setInstructions,
    instructions33 = [],
    Tabname,
    currentData,
    activeStep,
    instructions33default,
    setInstructionsdefault,
  } = useTaskContext();
useEffect(() => {
  // Load defaults only once when id changes
  if (id && (instructions33.length === 0 || (instructions33.length === 1 && instructions33[0].value === ""))) {
    const defaultWithIds = instructions33default.map((item, index) => ({
      ...item,
      id: item.id,
      media: item.bigimage
        ? [{
            type: "image",
            url: item.bigimage,
            file: new File([], item.bigimage.split('/').pop() ||""),
          }]
        : [],
    }));
    setInstructions(defaultWithIds);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [id, instructions33default]);

  // useEffect(() => {
  //   // Only load defaults if id is present
  //   if (id && (instructions33.length === 0 || (instructions33.length === 1 && instructions33[0].value === ""))) {
  //     const defaultWithIds = instructions33default.map((item, index) => ({
  //       ...item,
  //       id: item.id,
  //       media: item.bigimage ? [{
  //         type: "image",
  //         url: item.bigimage,
  //         file: new File([], item.bigimage.split('/').pop() || `image-${index}.jpg`)
  //       }] : []
  //     }));
  //     setInstructions(defaultWithIds);
  //   }
  // }, [id, instructions33default, instructions33, setInstructions]);

  const addInstruction = () => {
    const newId = instructions33 && instructions33.length > 0 ? Math.max(...instructions33.map((item) => item.id)) + 1 : 1;
    setInstructions([
      ...instructions33,
      {
        id: newId,
        value: "",
        value_hi: "",
        smallimage: "",
        bigimage: "",
        media: [],
      },
    ]);
  };
console.log(instructions33, "instructions3388555555555555")
  const removeInstruction = (id: number) => {
    setInstructions(instructions33.filter((instruction) => instruction.id !== id));
    const updatedImageMap = { ...imageMap };
    delete updatedImageMap[id];
    setImageMap(updatedImageMap);
  };

  const token = getToken();

  // const handleSmallImageUpload = async (id: number, file: File | null) => {
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("answer", file);

  //   try {
  //     const response = await uploadimagetask(formData, token);
  //     const uploadedFileName = response.data.answer;

  //     if (!uploadedFileName) return;

  //     setInstructions((prevInstructions) =>
  //       prevInstructions.map((instruction) => {
  //         if (instruction.id === id) {
  //           return { ...instruction, smallimage: uploadedFileName };
  //         }
  //         return instruction;
  //       })
  //     );
  //   } catch (error) {
  //     console.error("Error uploading small image:", error);
  //   }
  // };

  const handleSmallImageUpload = async (id: number, file: File | null) => {
  if (!file) return;

  const formData = new FormData();
  formData.append("answer", file);

  try {
    const response = await uploadimagetask(formData, token);
    const uploadedFileName = response.data.answer;

    if (!uploadedFileName) return;

    const previewUrl = URL.createObjectURL(file);

    setInstructions((prevInstructions) =>
      prevInstructions.map((instruction) =>
        instruction.id === id
          ? {
              ...instruction,
              smallimage: uploadedFileName,      // 👈 filename from API (for DB)
              _previewSmallImage: previewUrl,    // 👈 blob only for UI
            }
          : instruction
      )
    );
  } catch (error) {
    console.error("Error uploading small image:", error);
  }
};


  const handleBigImageUpload = async (id: number, files: FileList | null) => {
  if (!files || files.length === 0) return;

  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append("answer", file));

  try {
    const response = await uploadimagetask(formData, token);
    const uploadedFileNames = response.data.answer;

    if (!uploadedFileNames) return;

    const fileNamesArray = Array.isArray(uploadedFileNames)
      ? uploadedFileNames
      : uploadedFileNames.split(",");

    const newFiles: MediaItem[] = Array.from(files).map((file) => ({
      type: file.type.startsWith("video") ? "video" : "image",
      url: URL.createObjectURL(file), // blob preview for UI
      file,
    }));

    setInstructions((prevInstructions) =>
      prevInstructions.map((instruction) =>
        instruction.id === id
          ? {
              ...instruction,
              bigimage: [
                ...(instruction.bigimage ? instruction.bigimage.split(",") : []), // keep old ones
                ...fileNamesArray, // append new ones
              ].join(","),

              media: [...(instruction.media || []), ...newFiles], // append previews
            }
          : instruction
      )
    );

    setImageMap((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), ...newFiles.map((file) => file.url)],
    }));
  } catch (error) {
    console.error("Error uploading big image:", error);
  }
};


  const handleImageDelete = (id: number, type: "big" | "small") => {
    setInstructions((prevInstructions) =>
      prevInstructions.map((instruction) =>
        instruction.id === id
          ? {
              ...instruction,
              [type === "big" ? "bigimage" : "smallimage"]: "",
              ...(type === "big" ? { media: [] } : {}),
            }
          : instruction
      )
    );

    if (type === "big") {
      setImageMap((prev) => ({
        ...prev,
        [id]: [],
      }));
    }
  };

  const clickedItem = useRef<number>(0);
  const cleckedItemHolder = useRef<number>(0);

  function handleSort() {
    const dragList = [...instructions33];
    const temp = dragList[clickedItem.current];
    dragList[clickedItem.current] = dragList[cleckedItemHolder.current];
    dragList[cleckedItemHolder.current] = temp;
    setInstructions(dragList);
  }

  const handleInstructionChange = (id: number, newValue: string) => {
    setInstructions((prev) =>
      prev.map((instruction) => {
        if (instruction.id !== id) return instruction;

        const updatedInstruction = { ...instruction };

        if (activeStep === 1) {
          const oldValue = instruction.value;
          updatedInstruction.value = newValue;

          // Auto-sync to value_hi if it's empty or matches old value
          if (!updatedInstruction.value_hi || updatedInstruction.value_hi.trim() === "" || updatedInstruction.value_hi === oldValue) {
            updatedInstruction.value_hi = newValue;
          }
        } else if (activeStep === 2) {
          updatedInstruction.value_hi = newValue;
        }

        return updatedInstruction;
      })
    );
  };

  const handleRemoveFile = (instructionId: number, fileIndex: number) => {
    setInstructions((prev) =>
      prev.map((inst) =>
        inst.id === instructionId
          ? {
              ...inst,
              media: inst.media?.filter((_: any, idx: number) => idx !== fileIndex),
              bigimage: inst.bigimage
                ? inst.bigimage
                    .split(',')
                    .filter((_, idx) => idx !== fileIndex)
                    .join(',')
                : '',
            }
          : inst
      )
    );

    setImageMap((prev) => ({
      ...prev,
      [instructionId]: prev[instructionId]?.filter((_, idx) => idx !== fileIndex) || [],
    }));
  };
console.log(instructions33, "instructions33ss")
  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      {(Tabname === "Dotcode Scanning Task" || Tabname === "डॉटकोड स्कैनिंग कार्य") ? (
        <Box className={containerClassName} sx={{ width: "100%", marginLeft: "50px" }}>
          {instructions33.map((instruction, index) => (
            <React.Fragment key={instruction.id}>
              <Box
                draggable
                onDragStart={() => (clickedItem.current = index)}
                onDragEnter={() => (cleckedItemHolder.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "22px",
                  position: "relative",
                }}
              >
                <span style={{ cursor: "grabbing", color: "#525252", fontSize: "19px" }}>⋮⋮</span>

                <Fileupload
                  fileuploadclass="instruction-upload"
                  iconSrc={galleryadd}
                  previewImage={instruction.smallimage}
                  {...((activeStep === 1 || activeStep === 2) && {
                    onFileSelect: (file) => handleSmallImageUpload(instruction.id, file),
                    onRemoveFile: () => handleImageDelete(instruction.id, "small"),
                  })}
                  previewSize={{ width: 24, height: 24 }}
                />

                <TextField
                  sx={{
                    ".MuiInputBase-input": {
                      padding: "16px",
                      color: "#171717",
                      fontSize: "16px",
                      fontWeight: "500",
                      background: "#F9FBFC",
                      borderRadius: "10px",
                      width: "100%",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  id={`Instruction-${instruction.id}`}
                  placeholder={`${placeholderPrefix} ${instruction.id}`}
                  value={activeStep === 1 ? instruction.value : instruction.value_hi}
                  onChange={(e) => handleInstructionChange(instruction.id, e.target.value)}
                />

                <Tooltip title="Upload Image and Video" arrow>
                  <Button
                    sx={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "1px solid #F1F2F3",
                      borderRadius: "10px",
                      padding: "16px",
                      "&:hover": { boxShadow: "none" },
                    }}
                    variant="contained"
                    component="label"
                  >
                    <img crossOrigin="anonymous" src={galleryadd} alt="galleryadd" />
                    <input
                      type="file"
                      hidden
                      multiple
                      accept="image/*,video/*"
                      onChange={(e) => handleBigImageUpload(instruction.id, e.target.files)}
                    />
                  </Button>
                </Tooltip>

                <Tooltip title="Delete Instruction" arrow>
                  <Button
                    onClick={() => removeInstruction(instruction.id)}
                    sx={{
                      border: "1px solid #F1F2F3",
                      padding: "16px",
                      borderRadius: "10px",
                      minWidth: "56px",
                      height: "56px",
                      "&:hover": { backgroundColor: "transparent !important" },
                      ".MuiTouchRipple-root": { display: "none" },
                    }}
                  >
                    <img crossOrigin="anonymous" style={{ cursor: "pointer" }} src={trash} alt="trash" height={24} width={24} />
                  </Button>
                </Tooltip>
              </Box>

              <Box className="showimages" sx={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "22px" }}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
                  {instruction.media?.map((item: MediaItem, idx: number) => (
                    <Box key={idx} sx={{ position: "relative" }}>
                      {item.type === "image" ? (
                        <img   crossOrigin="anonymous"
 src={item.url} alt={`upload-${idx}`} style={{ width: 120, height: 120, borderRadius: "8px", objectFit: "cover" }} />
                      ) : (
                        <video src={item.url} controls style={{ width: 150, height: 120, borderRadius: "8px" }} />
                      )}
                      <Button
                        size="small"
                        sx={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          minWidth: "24px",
                          height: "24px",
                          borderRadius: "6px",
                          background: "#FFF",
                          boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.10)",
                          padding: "0",
                        }}
                        onClick={() => handleRemoveFile(instruction.id, idx)}
                      >
                        <img crossOrigin="anonymous" src={cancel} alt="delete" width={24} height={24} />
                      </Button>
                    </Box>
                  ))}
                </Box>
              </Box>
            </React.Fragment>
          ))}

          <Button onClick={addInstruction} sx={{ padding: "0", textTransform: "capitalize", fontSize: "14px", fontWeight: "500", color: "#C8172F" }}>
            <img style={{ marginRight: "8px" }} src={plus} alt="plus" /> {lang.addInstruction}
          </Button>
        </Box>
      ) : (
        <Box className={containerClassName} sx={{ width: "100%", marginLeft: "50px" }}>
          {instructions33.map((instruction, index) => (
            <React.Fragment key={instruction.id}>
              <Box
                draggable
                onDragStart={() => (clickedItem.current = index)}
                onDragEnter={() => (cleckedItemHolder.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "22px",
                  position: "relative",
                }}
              >
                <span style={{ cursor: "grabbing", color: "#525252", fontSize: "19px" }}>⋮⋮</span>

                <Fileupload
                  fileuploadclass="instruction-upload"
                  iconSrc={galleryadd}
                  previewImage={instruction.smallimage}
                  
                  {...((activeStep === 1 || activeStep === 2) && {
                    onFileSelect: (file) => handleSmallImageUpload(instruction.id, file),
                    onRemoveFile: () => handleImageDelete(instruction.id, "small"),
                  })}
                  previewSize={{ width: 24, height: 24 }}
                />

                <TextField
                  sx={{
                    ".MuiInputBase-input": {
                      padding: "16px",
                      color: "#171717",
                      fontSize: "16px",
                      fontWeight: "500",
                      background: "#F9FBFC",
                      borderRadius: "10px",
                      width: "100%",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  id={`Instruction-${instruction.id}`}
                  placeholder={`${placeholderPrefix} ${instruction.id}`}
                  value={activeStep === 1 ? instruction.value : instruction.value_hi}
                  onChange={(e) => handleInstructionChange(instruction.id, e.target.value)}
                />

                <Tooltip title="Delete Instruction" arrow>
                  <Button
                    onClick={() => removeInstruction(instruction.id)}
                    sx={{
                      border: "1px solid #F1F2F3",
                      padding: "16px",
                      borderRadius: "10px",
                      minWidth: "56px",
                      height: "56px",
                      "&:hover": { backgroundColor: "transparent !important" },
                      ".MuiTouchRipple-root": { display: "none" },
                    }}
                  >
                    <img crossOrigin="anonymous" style={{ cursor: "pointer" }} src={trash} alt="trash" height={24} width={24} />
                  </Button>
                </Tooltip>
              </Box>
            </React.Fragment>
          ))}

          <Button onClick={addInstruction} sx={{ padding: "0", textTransform: "capitalize", fontSize: "14px", fontWeight: "500", color: "#C8172F" }}>
            <img style={{ marginRight: "8px" }} src={plus} alt="plus" /> {lang.addInstruction}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Instruction;